import { useSelector } from 'react-redux'
import { formatText } from '../../../../../../helpers/value'
import { Translate } from 'react-redux-i18n'

export const TypeAndVersion = ({ val, rowId, getDataFromRedux }) => {
  const readyVersion = useSelector(getDataFromRedux(rowId, 'readyVersion'))

  return (
    <>
      <div>{formatText(val)}</div>
      <div>
        (
        <Translate
          value={`userManagement.orderManagement.orderDetail.${
            readyVersion ? 'READY_TO_USE' : 'ON_REQUEST'
          }`}
        />
        )
      </div>
    </>
  )
}
